"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = removeDataKeys;

var _defs = _interopRequireDefault(require("../_core/defs"));

var _triggerone = _interopRequireDefault(require("../trigger/_triggerone"));

var _seempleerror = _interopRequireDefault(require("../_helpers/seempleerror"));

var _foreach = _interopRequireDefault(require("../_helpers/foreach"));

// removes given keys from a list of data keys
function removeDataKeys(givenKeys) {
  var _this = this;

  var def = _defs["default"].get(this);
  /* istanbul ignore if */


  if (!def) {
    return this;
  }

  var keys = def.keys;
  var removedKeys; // accept an array keys or a list of args

  if (givenKeys instanceof Array) {
    removedKeys = givenKeys;
  } else {
    removedKeys = arguments;
  }

  (0, _foreach["default"])(removedKeys, function (key) {
    if (typeof key !== 'string') {
      throw (0, _seempleerror["default"])('removedatakeys:key_type', {
        key: key
      });
    }

    if (key in keys) {
      var eventOptions = {
        key: key,
        value: _this[key]
      };
      delete keys[key]; // fire "modify" and "remove" events

      (0, _triggerone["default"])(_this, 'modify', eventOptions);
      (0, _triggerone["default"])(_this, 'remove', eventOptions);
    }
  });
  return this;
}
//# sourceMappingURL=removedatakeys.js.map